/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import clsx from 'clsx';
import React from 'react';
import { LinkListProps } from './LinkList.props';

/**
 * SDS LinkList component.
 */
export const LinkList = (props: LinkListProps): JSX.Element => {
  const { classes, heading, linkKeys, links, ...rest } = props;
  const wrapperClass = clsx(`sds-link-list__wrapper`, classes);

  const getLinks = (): Array<JSX.Element> => {
    return links.map((link, index): JSX.Element => {
      return <li key={linkKeys[index]}>{link}</li>;
    });
  };

  if (links.length > 0) {
    return (
      <div className={wrapperClass}>
        {heading && <span className="sds-link-list__heading">{heading}</span>}
        <ul className="sds-link-list" {...rest}>
          {getLinks()}
        </ul>
      </div>
    );
  }

  return <></>;
};
